module.exports = __webpack_public_path__ + "static/media/d2kz.3a8e4473.pdf";